<template>
  <div v-if="payload">
    <router-link 
      :to="{ name: simplifiedData.route_name, query: simplifiedData.query }"
      :class="{ un_clickable: simplifiedData.route_name == undefined }" 
      class="blue_text link-entity"
    >
      <u @mouseover="onMouseOver" @mouseleave="onMouseLeave">{{simplifiedData.display_text}}</u>
    </router-link>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'link_entity',
  props: ['payload', 'additional_data'],
  computed: {
    mergedData () {
      return { ...this.payload, ...this.additional_data }
    },
    simplifiedData: function () {
      if (this.mergedData.resource_type == 'Company') {
        return {
          route_name: 'companies',
          modal_name: 'CompanyForm',
          query: { show_id: this.payload.id },
          display_text: `${this.payload.name}${this.payload.has_contract ? '' : ' (NO CONTRACT)'}`,
        }
      }
      if (this.mergedData.resource_type == 'Offer') {
        return {
          route_name: 'offers',
          query: { show_id: this.payload.id },
          modal_name: 'OfferForm',
          display_text: this.payload.applicant_name + ' (' + this.payload.company.name + ')',
        }
      }
      return {}
    },
    ...mapGetters('modals', ['isModalOpen', 'findModal'])
  },
  methods: {
    onMouseOver () {
      this.createModal({
        designator: 'link-entity-resource-modal',
        resource_type: this.mergedData.resource_type,
        resource_id: this.mergedData.resource_id,
        component_name: this.simplifiedData.modal_name,
        data: this.mergedData,
        modal_title: this.simplifiedData.display_text,
        is_view_mode: false
      })
    },
    onMouseLeave () {
      if (!this.isModalOpen({ type: 'designator', value: 'link-entity-resource-modal' })) {
        return
      }
      this.removeModal(this.getModal())
    },
    getModal () {
      return this.findModal({ type: 'designator', value: 'link-entity-resource-modal' })
    },
    ...mapMutations('modals', ['removeModal', 'createModal'])
  },
}
</script>
<style scoped>
  .un_clickable{
    pointer-events: none;
  }
  .link-entity{
    color: #3273dc !important;
  }
</style>
